import "./ProgressBar.css";

function ProgressBar({ exportProgress }) {
  if (exportProgress >= 100) return null;

  return (
    <div className='progress-bar-wrap'>
      <div className='progress-bar-wrap__container'>
        <div className='progress-bar-wrap__bar' style={{ width: `${exportProgress}%` }} />
      </div>
      <span className='progress-bar-wrap__label'>{exportProgress}%</span>
    </div>
  );
}

export default ProgressBar;
